/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentsId
 */
export interface DocumentsId {
    /**
     * 
     * @type {Array<number>}
     * @memberof DocumentsId
     */
    documentsId?: Array<number>;
}

/**
 * Check if a given object implements the DocumentsId interface.
 */
export function instanceOfDocumentsId(value: object): value is DocumentsId {
    return true;
}

export function DocumentsIdFromJSON(json: any): DocumentsId {
    return DocumentsIdFromJSONTyped(json, false);
}

export function DocumentsIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentsId {
    if (json == null) {
        return json;
    }
    return {
        
        'documentsId': json['documentsId'] == null ? undefined : json['documentsId'],
    };
}

export function DocumentsIdToJSON(json: any): DocumentsId {
    return DocumentsIdToJSONTyped(json, false);
}

export function DocumentsIdToJSONTyped(value?: DocumentsId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentsId': value['documentsId'],
    };
}

